import { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/site/Header";
import SideMenu from "@/components/site/SideMenu";
import Footer from "@/components/site/Footer";
import { useSite } from "@/hooks/useSite";

export default function SiteShell({ env = "live" }) {
  const site = useSite(env);
  const staging = env === "staging";

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  if (site === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-paper" data-testid="site-loading">
        <p className="font-serif text-2xl text-brass animate-pulse">Setting the table…</p>
      </div>
    );
  }
  if (site === false) {
    return <div className="flex h-screen items-center justify-center bg-paper text-ink2" data-testid="site-error">The kitchen is closed right now — please try again shortly.</div>;
  }

  const base = staging ? "/staging" : "";
  return (
    <div className="grain min-h-screen bg-paper">
      <div className="pointer-events-none fixed inset-y-0 left-4 sm:left-14 lg:left-20 w-px bg-ink/10 z-[45]" data-testid="frame-line-left" />
      <div className="pointer-events-none fixed inset-y-0 right-4 sm:right-14 lg:right-20 w-px bg-ink/10 z-[45]" data-testid="frame-line-right" />
      {staging && (
        <div className="fixed bottom-4 left-4 z-[70] rounded-full border border-flame/60 bg-paper/90 px-5 py-2 text-xs font-mono uppercase tracking-widest text-flame backdrop-blur" data-testid="staging-banner">
          Staging Preview — <Link to="/admin" className="underline">publish in admin</Link>
        </div>
      )}
      <Header settings={site.settings} base={base} />
      <SideMenu settings={site.settings} base={base} />
      <Outlet context={{ settings: site.settings, env, base }} />
      <Footer settings={site.settings} base={base} />
    </div>
  );
}
